/* SpawnAnything — the menu window every setup menu shares (Welt, Bauen, Items, Armeen, Sammlung): backdrop, framed box
   with a sticky head (title, subtitle, ✕), a scrolling body and a foot with the "Fertig" button. Escape and a click on
   the backdrop close it. Looks follow the UI theme (src/ui/theme.css) through the shared variables. */
import './window.css';
import { getPreview3D } from './preview3d.js';

const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const open = new Set();

/** opts: { id, title, sub, icon (tabler class), wide, foot (text), done ('Fertig') } */
export function createWindow({ id, title, sub = '', icon = '', wide = false, foot = '', done = 'Fertig' } = {}) {
  const modal = document.createElement('div');
  modal.className = 'aw-win'; modal.hidden = true; if (id) modal.id = id;
  modal.innerHTML = `<div class="aw-win-box${wide ? ' wide' : ''}" role="dialog" aria-modal="true" aria-labelledby="${id || 'w'}T">
    <div class="aw-win-head">${icon ? `<i class="ti ${icon}" aria-hidden="true"></i>` : ''}<h2 id="${id || 'w'}T">${esc(title)}</h2><span class="aw-win-sub">${esc(sub)}</span><button class="aw-win-x" type="button" aria-label="Schließen">✕</button></div>
    <div class="aw-win-body"></div>
    <div class="aw-win-foot"><span class="aw-win-note">${esc(foot)}</span><button class="go aw-win-ok" type="button">${esc(done)}</button></div>
  </div>`;
  document.body.appendChild(modal);
  const body = modal.querySelector('.aw-win-body'), footEl = modal.querySelector('.aw-win-foot');
  const onOpen = [], onClose = [];
  const W = {
    el: modal, box: modal.querySelector('.aw-win-box'), body, foot: footEl, note: modal.querySelector('.aw-win-note'),
    get isOpen() { return !modal.hidden; },
    open() {
      if (!modal.hidden) return;
      for (const w of [...open]) w.close(); // one menu at a time
      modal.hidden = false; open.add(W);
      for (const f of onOpen) f();
      getPreview3D().wake();
      modal.querySelector('.aw-win-ok').focus({ preventScroll: true });
    },
    close() { if (modal.hidden) return; modal.hidden = true; open.delete(W); for (const f of onClose) f(); },
    toggle() { if (modal.hidden) W.open(); else W.close(); },
    onOpen: f => onOpen.push(f), onClose: f => onClose.push(f),
    setNote(t) { W.note.textContent = t; },
  };
  modal.querySelector('.aw-win-x').addEventListener('click', W.close);
  modal.querySelector('.aw-win-ok').addEventListener('click', W.close);
  modal.addEventListener('pointerdown', e => { if (e.target === modal) W.close(); });
  body.addEventListener('scroll', () => getPreview3D().renderNow(), { passive: true }); // models stick to their cards
  return W;
}
addEventListener('keydown', e => { if (e.key === 'Escape' && open.size) { e.stopPropagation(); for (const w of [...open]) w.close(); } }, true);
/** true while any menu window is open (main.js: no camera drag / placing behind it) */
export const anyWindowOpen = () => open.size > 0;

/** a card grid helper: cards are <button class="aw-card"> with a 3D view, a title and a line of text */
export function card({ title, text = '', tag = '', locked = false, on = false, cls = '' }) {
  const b = document.createElement('button');
  b.type = 'button'; b.className = 'aw-card ' + cls + (locked ? ' locked' : '');
  b.setAttribute('aria-pressed', String(!!on));
  b.innerHTML = `<span class="aw-card-view"></span><span class="aw-card-t">${esc(title)}${tag ? ` <em>${esc(tag)}</em>` : ''}</span>${text ? `<span class="aw-card-s">${esc(text)}</span>` : ''}`;
  return b;
}
